<!-- search input -->
<mat-form-field class="tw-w-full map-search-box-input" appearance="outline">
  <mat-label class="dark:tw-bg-[#3d3d58]">
    <span class="dark:tw-bg-[#3d3d58] tw-p-1 tw-rounded-tr-sm tw-rounded-tl-sm">
      {{ "common.search" | translate }}
    </span>
  </mat-label>

  <div class="tw-relative search-box tw-flex-center tw-w-full tw-relative">
    <input
      type="text"
      #mapSearchInput
      matInput
      [formControl]="myControl"
      [matAutocomplete]="auto"
      (keydown)="stopPropagationInput($event)"
    />
    <i
      *ngIf="!loadingPublic"
      class="tw-absolute tw-left-[12px] mdi mdi-magnify mdi-24px text-dark"
    ></i>
    <i
      *ngIf="loadingPublic"
      class="tw-absolute tw-left-[12px] mdi mdi-sync mdi-24px mdi-spin text-dark bg-white"
    ></i>
  </div>

  <mat-autocomplete
    class="map-search-box-aut-complete"
    #auto="matAutocomplete"
    (opened)="onScrollDown()"
  >
    <div>
      <mat-option
        class="map-option-search-suggest tw-border-b tw-border-b-gray-200 dark:tw-border-b-gray-500"
        (click)="emitSelectedPlace(item)"
        *ngFor="
          let item of filteredOptions;
          trackBy: trackByFunc;
          let i = index
        "
        [value]="item.title"
        style="white-space: normal; height: initial !important"
      >
        <span class="mdc-list-item__primary-text">
          <div style="display: flex; flex-direction: column; padding: 4px 0">
            <div class="tw-flex tw-items-center">
              <b class="tw-flex tw-text-[13px] dark:tw-text-gray-200">
                {{ item.title }}
              </b>
              <ng-container
                *ngIf="
                  (item?.type | lowercase) != 'point' &&
                  (item?.type | lowercase) != 'area'
                "
              >
                <span
                  class="tw-text-[11.5px] tw-px-[6px] tw-bg-gray-200 dark:tw-bg-slate-600 dark:tw-text-gray-200 tw-rounded-full tw-font-medium"
                >
                  {{ (item.type | mapSearchItemType) | translate }}
                </span>
              </ng-container>
            </div>
            <div
              class="tw-mt-1.5 tw-text-gray-500 dark:tw-text-gray-100 tw-text-[11.5px]"
            >
              {{ item.address }}
            </div>
          </div>
        </span>

        <!-- <b class="tw-flex tw-text-[13px] dark:tw-text-gray-200 tw-justify-between tw-items-center">{{item.title}}
                    <ng-container *ngIf="(item?.type|lowercase)!='point' && (item?.type|lowercase)!='area'">
                        <span
                            class="tw-text-[11.5px] tw-px-[6px] tw-bg-gray-200 dark:tw-bg-slate-600 dark:tw-text-gray-200 tw-rounded-full tw-font-medium">
                            {{item.type}}
                        </span>
                    </ng-container>
                </b>
                <span class="tw-mt-1.5 tw-text-gray-500 dark:tw-text-gray-100 tw-text-[11.5px]">

                </span> -->
      </mat-option>
    </div>
  </mat-autocomplete>
</mat-form-field>
